import React from 'react';
import { LuShieldCheck } from 'react-icons/lu';
import { HiArrowRight } from 'react-icons/hi';

export default function AuditAccessBanner() {
  return (
    <div className="mx-6 my-4 flex flex-col gap-4 rounded-xl border border-indigo-100 bg-[#fbfbfe] p-4 sm:flex-row sm:items-center sm:justify-between">
      {/* Left Content Side */}
      <div className="flex items-start gap-3.5 sm:items-center">
        {/* Shield Icon Badge */}
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-indigo-50 text-indigo-600 border border-indigo-100/50">
          <LuShieldCheck className="h-5 w-5" />
        </div>
        
        {/* Text Section */}
        <div className="space-y-0.5">
          <h3 className="text-sm font-bold text-slate-900">
            Need to give access to an inspector?
          </h3>
          <p className="text-xs font-medium text-slate-500 leading-relaxed">
            Use <span className="font-semibold text-indigo-600 hover:underline cursor-pointer">Audit / Inspector Access</span> to control what inspectors can see during an inspection.
          </p>
        </div>
      </div>

      {/* Right Action Button */}
      <button className="flex items-center justify-center gap-2 rounded-lg border border-slate-200 bg-white px-4 py-2 text-xs font-bold text-slate-800 shadow-sm transition hover:bg-slate-50 active:bg-slate-100 whitespace-nowrap self-end sm:self-auto">
        <span>Go to Audit Access</span>
        <HiArrowRight className="h-4 w-4 text-slate-600" />
      </button>
    </div>
  );
}
